import { object, string } from 'yup'

export const schema = object().shape({
  changeEmail: string()
    .email('Invalid email address')
    .required('Please enter the required field'),
})
